/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable no-underscore-dangle */
/* eslint-disable @angular-eslint/no-host-metadata-property */
/* eslint-disable @angular-eslint/no-inputs-metadata-property */
import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';
import { CDK_TREE_NODE_OUTLET_NODE, CdkNestedTreeNode, CdkTree, CdkTreeNode, CdkTreeNodeDef } from '@angular/cdk/tree';
import {
  AfterContentInit,
  Attribute,
  Directive,
  ElementRef,
  Input,
  IterableDiffers,
  OnDestroy,
  OnInit,
} from '@angular/core';

export interface NestedTreeNode {
  name: string;
  children?: NestedTreeNode[];
}

export interface FlatTreeNode {
  expandable: boolean;
  name: string;
  level: number;
}

// const _NTreeNodeBase = mixinTabIndex(mixinDisabled(CdkTreeNode));

/**
 * Wrapper for the CdkTree node.
 */
@Directive({
  selector: 'n-tree-node',
  exportAs: 'nTreeNode',
  inputs: ['role', 'disabled', 'tabIndex'],
  providers: [{ provide: CdkTreeNode, useExisting: NTreeNodeDirective }],
  host: {
    class: 'n-tree-node',
  },
})
export class NTreeNodeDirective<T, K = T> extends CdkTreeNode<T, K> implements OnInit, OnDestroy {
  constructor(elementRef: ElementRef<HTMLElement>, tree: CdkTree<T, K>, @Attribute('tabindex') tabIndex: string) {
    super(elementRef, tree);
    // this.tabIndex = Number(tabIndex) || 0;
  }

  // // This is a workaround for https://github.com/angular/angular/issues/23091
  // // In aot mode, the lifecycle hooks from parent class are not called.
  override ngOnInit() {
    super.ngOnInit();
  }

  override ngOnDestroy() {
    super.ngOnDestroy();
  }
}

/**
 * Wrapper for the CdkTree node definition.
 * Captures the node's template and a when predicate that describes when this node should be used.
 */
@Directive({
  selector: '[nTreeNodeDef]',
  inputs: ['when: nTreeNodeDefWhen'],
  providers: [{ provide: CdkTreeNodeDef, useExisting: NTreeNodeDefDirective }],
})
export class NTreeNodeDefDirective<T> extends CdkTreeNodeDef<T> {
  @Input('nTreeNode') data: T;
}

/**
 * Wrapper for the CdkTree nested node.
 */
@Directive({
  selector: 'n-nested-tree-node',
  exportAs: 'nNestedTreeNode',
  inputs: ['role', 'disabled', 'tabIndex'],
  providers: [
    { provide: CdkNestedTreeNode, useExisting: NNestedTreeNodeDirective },
    { provide: CdkTreeNode, useExisting: NNestedTreeNodeDirective },
    { provide: CDK_TREE_NODE_OUTLET_NODE, useExisting: NNestedTreeNodeDirective },
  ],
  host: {
    class: 'n-nested-tree-node',
  },
})
export class NNestedTreeNodeDirective<T, K = T>
  extends CdkNestedTreeNode<T, K>
  implements AfterContentInit, OnDestroy, OnInit
{
  @Input('nNestedTreeNode') node: T;

  /** Whether the node is disabled. */
  @Input()
  get disabled(): boolean {
    return this._disabled;
  }
  set disabled(value: BooleanInput) {
    this._disabled = coerceBooleanProperty(value);
  }
  private _disabled = false;

  /** Tabindex for the node. */
  @Input()
  get tabIndex(): number {
    return this.disabled ? -1 : this._tabIndex;
  }
  set tabIndex(value: number) {
    // If the specified tabIndex value is null or undefined, fall back to the default value.
    this._tabIndex = value !== null && value !== undefined ? value : 0;
  }
  private _tabIndex: number;

  constructor(
    elementRef: ElementRef<HTMLElement>,
    tree: CdkTree<T, K>,
    differs: IterableDiffers,
    @Attribute('tabindex') tabIndex: string,
  ) {
    super(elementRef, tree, differs);
    this.tabIndex = Number(tabIndex) || 0;
  }

  // // This is a workaround for https://github.com/angular/angular/issues/19145
  // // In aot mode, the lifecycle hooks from parent class are not called.
  // // TODO(tinayuangao): Remove when the angular issue #19145 is fixed
  override ngOnInit() {
    super.ngOnInit();
  }

  override ngAfterContentInit() {
    super.ngAfterContentInit();
  }

  override ngOnDestroy() {
    super.ngOnDestroy();
  }
}
